// Product share links. The apex site is a Lovable-hosted SPA, so its server HTML is the
// same generic shell for every URL and WhatsApp/Facebook previews can't show the product.
// The feed. Worker's /p/:ws_code route serves per-product Open Graph tags and then
// redirects people to the real product page — see docs/feed-worker-with-sitemap-route.js.
const SHARE_ORIGIN = 'https://feed.veevoerwinkel.co.za';

export const buildProductShareUrl = (wsCode: string): string =>
  `${SHARE_ORIGIN}/p/${encodeURIComponent(wsCode.trim().toUpperCase())}`;

// No phone number: wa.me/?text= lets the customer pick who to send it to.
export const buildWhatsAppShareUrl = (productName: string, wsCode: string): string =>
  `https://wa.me/?text=${encodeURIComponent(`${productName} ${buildProductShareUrl(wsCode)}`)}`;
